<template>
    <div class="vrm-pagination-list">
        <button
            v-if="canScrollLeft"
            type="button"
            class="button--left vrm-pagination-arrow"
            @click.prevent.stop="scrollLeft"
        >
            <i class="sg-vrm-icon_048_arrow-left-16px" />
        </button>
        <div class="vrm-pagination-list__items">
            <component
                :is="itemComponent"
                v-for="item in visibleItems"
                :key="item.id + item.timestamp"
                :class="{ 'vrm-pagination-item-divider': divider }"
                :item="item"
                :detail-mode="detailMode"
            />
        </div>
        <button
            v-if="canScrollRight"
            type="button"
            class="button--right vrm-pagination-arrow"
            @click.prevent.stop="scrollRight"
        >
            <i class="sg-vrm-icon_049_arrow-right-16px" />
        </button>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { WindowEventListener } from '@/vue/decorators/window-event-listener';
import { clamp } from '@/vue/helpers/math';
import VrmTank from '@/vue/components/shared/VrmTank';
import VrmTemperature from '@/vue/components/shared/VrmTemperature';

@Component({
    components: {
        // For this component to handle different items, please add them here
        VrmTank,
        VrmTemperature,
    },
})
@AngularDirective('vrm-pagination-list')
export default class VrmPaginationList extends Vue {
    @Prop()
    items;

    @Prop({ type: Number, default: 0 })
    threshold;

    @Prop({ type: Boolean, required: true })
    detailMode;

    @Prop({ type: Boolean, required: false })
    divider;

    @Prop({ type: Number, default: 4 })
    itemsPer;

    @Prop({ type: String, default: 'vrm-tank' })
    itemComponent;

    maxVisible = this.itemsPer;
    visibleOffset = 0;

    created() {
        this.onWindowResized();
    }

    @WindowEventListener('resize')
    onWindowResized() {
        this.maxVisible = window.innerWidth < 1280 ? this.itemsPer - 1 : this.itemsPer;
    }

    // Pagination logic
    get itemsCount() {
        return this.items.length;
    }

    get maxOffset() {
        return this.showPagination ? this.itemsCount - this.maxVisible : 0;
    }

    get showPagination() {
        return this.itemsCount > this.maxVisible;
    }

    get visibleItems() {
        if (this.showPagination) {
            return this.items.slice(this.visibleOffset, this.visibleOffset + this.maxVisible);
        } else {
            return this.items;
        }
    }

    scrollLeft() {
        this.visibleOffset = clamp(0, this.maxOffset, this.visibleOffset - 1);
    }

    scrollRight() {
        this.visibleOffset = clamp(0, this.maxOffset, this.visibleOffset + 1);
    }

    get canScrollLeft() {
        return this.showPagination && this.visibleOffset > 0;
    }

    get canScrollRight() {
        return this.showPagination && this.visibleOffset < this.maxOffset;
    }

    get hasLow() {
        return this.items.some(item => item.isLow);
    }
}
</script>
